import { Splash } from "@/components/common";
import { useAuth } from "@/hooks";
import { SessionRecovery } from "../session-recovery";
import { Navigate } from "react-router-dom";

interface PrivateRouteProps {
  children: React.ReactElement;
}

export function PrivateRoute({ children }: PrivateRouteProps) {
  const { accessToken, user, isLoading, isDisconnected, sessionStatus, initialize } = useAuth();

  if (isLoading && !user) {
    return <Splash />;
  }

  const blocked = sessionStatus === "checking" || sessionStatus === "unavailable";

  if ((!accessToken || !user || isDisconnected) && !blocked) {
    const returnTo = encodeURIComponent(
      isDisconnected ? "/" : location.pathname + location.search
    );
    return <Navigate to={`/auth?returnTo=${returnTo}`} replace />;
  }

  return <SessionRecovery blocked={blocked} pending={sessionStatus === "checking"} onRetry={initialize}>
    {accessToken && user && !isDisconnected ? children : null}
  </SessionRecovery>;
}
